module.exports = new __parcel__URL__("underwater_bg.5b78c4fe.jpg").toString();